'use client';
import { useEffect } from 'react';
import { useBranding } from '@/contexts/BrandingContext';

export default function DynamicTitle() {
  const { branding } = useBranding();

  useEffect(() => {
    if (branding?.productName) {
      document.title = branding?.tagline
        ? `${branding?.productName} — ${branding?.tagline}`
        : branding?.productName;
    }
  }, [branding?.productName, branding?.tagline]);

  return null;
}
